import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumb from "@/components/Breadcrumb";
import { FadeIn, MaskedLine } from "@/components/Reveal";
import { legalPages } from "@/data/legalPages";

export default function LegalPage({ page }) {
  const other = legalPages.find((p) => p.slug !== page.slug);
  return (
    <>
      <Seo title={page.metaTitle} description={page.metaDescription} path={`/${page.slug}`} />
      <Breadcrumb items={[{ label: "Accueil", to: "/" }, { label: page.label }]} />
      <section className="bg-midnight text-white grain relative overflow-hidden">
        <div className="absolute inset-0 blueprint-dark opacity-60" aria-hidden="true" />
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 pt-16 pb-14 md:pt-24 md:pb-16">
          <MaskedLine delay={0.05}>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-signal">MSC Toitures — Informations</span>
          </MaskedLine>
          <h1 className="mt-5 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl" data-testid="legal-page-title">
            <MaskedLine delay={0.18}>{page.h1}</MaskedLine>
          </h1>
        </div>
      </section>

      <section className="bg-bone py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-5 md:px-10 space-y-14">
          {page.blocks.map((block, i) => (
            <FadeIn key={block.h2} delay={i * 0.05}>
              <div className="border-t border-midnight/10 pt-8" data-testid={`legal-block-${i}`}>
                <p className="font-mono text-sm text-signal tracking-[0.2em]">{String(i + 1).padStart(2, "0")}</p>
                <h2 className="mt-2 font-display font-black uppercase tracking-tight text-xl md:text-2xl">{block.h2}</h2>
                <div className="mt-5 space-y-3">
                  {block.paragraphs.map((p, j) => (
                    <p key={j} className="text-sm md:text-base text-midnight/70 leading-relaxed">{p}</p>
                  ))}
                </div>
              </div>
            </FadeIn>
          ))}
          <FadeIn delay={0.1}>
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border border-midnight/10 bg-white p-6 md:p-8">
              <div className="space-y-2">
                <Link to={`/${other.slug}`} data-testid="legal-other-link" className="block font-mono text-xs uppercase tracking-[0.2em] text-signal hover:underline">
                  Voir aussi : {other.label}
                </Link>
                <Link to="/" className="block font-mono text-xs uppercase tracking-[0.2em] text-midnight/50 hover:text-signal transition-colors duration-300">
                  Retour à l'accueil
                </Link>
              </div>
              <a
                href="tel:0646300391"
                data-testid="legal-call-button"
                className="btn-sweep inline-flex items-center gap-3 bg-signal text-white font-display font-bold text-sm uppercase tracking-wide px-6 py-3.5 transition-colors duration-300"
              >
                <Phone size={16} strokeWidth={1.5} />
                06 46 30 03 91
              </a>
            </div>
          </FadeIn>
        </div>
      </section>
    </>
  );
}
